import React, { useEffect, useState } from 'react';

import { notification } from '../../utils/notification';
import { TOAST_TYPE } from '../../utils/constant/errorMessage';

const copyText = async (text) => {
  if (navigator.clipboard?.writeText) {
    await navigator.clipboard.writeText(text);
    return;
  }
  const el = document.createElement('textarea');
  el.value = text;
  el.setAttribute('readonly', '');
  el.style.position = 'fixed';
  el.style.opacity = '0';
  document.body.appendChild(el);
  el.select();
  document.execCommand('copy');
  document.body.removeChild(el);
};

function CopyButton({ text, label = 'Copy', className = '' }) {
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (!copied) return undefined;
    const t = setTimeout(() => setCopied(false), 1500);
    return () => clearTimeout(t);
  }, [copied]);

  const handleCopy = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    try {
      await copyText(text);
      setCopied(true);
      notification('Copied to clipboard', TOAST_TYPE.TOAST_SUCCESS);
    } catch {
      notification('Could not copy', TOAST_TYPE.TOAST_ERROR);
    }
  };

  return (
    <button
      type="button"
      className={`ep-copy-btn${copied ? ' ep-copy-btn--done' : ''}${className ? ` ${className}` : ''}`}
      onClick={handleCopy}
      title={copied ? 'Copied' : label}
      aria-label={label}
    >
      <i className={`bi ${copied ? 'bi-check' : 'bi-clipboard'}`} aria-hidden />
    </button>
  );
}

export default CopyButton;
